import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdProvider } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const StyledList = /*#__PURE__*/styled.ol.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1do8u9s-0"
})(["font:", ";color:", ";margin:0;margin-inline-start:", ";display:block;padding:0;li & li{list-style:lower-alpha;li &{list-style:lower-roman;}}", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.list.marginInlineStart, isMobile(css(["font:", ";"], ({
  theme
}) => theme.font.text.base.mobile)));
const OrderedList = ({
  children,
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('ordered-list')
}, /*#__PURE__*/React__default.createElement(StyledList, rest, children));

export { OrderedList as O };
//# sourceMappingURL=OrderedList-DdPfU4IQ.js.map
